import { template as _$template } from "solid-js/web";
import { delegateEvents as _$delegateEvents } from "solid-js/web";
import { setAttribute as _$setAttribute } from "solid-js/web";
import { effect as _$effect } from "solid-js/web";
import { insert as _$insert } from "solid-js/web";
import { memo as _$memo } from "solid-js/web";
import { addEventListener as _$addEventListener } from "solid-js/web";
import { createComponent as _$createComponent } from "solid-js/web";
var _tmpl$ = /*#__PURE__*/_$template(`<a class="sat-info-value sat-info-link"target=_blank rel=noopener>`),
  _tmpl$2 = /*#__PURE__*/_$template(`<div class=sat-info-panel><div class=sat-info-header><span class=sat-info-title>SAT SELECTED</span><button class=sat-info-close>✕</button></div><div class=sat-info-body><div class=sat-info-row><span class=sat-info-label>NAME</span><span class=sat-info-value></span></div><div class=sat-info-row><span class=sat-info-label>NORAD</span></div><div class=sat-info-row><span class=sat-info-label>VEL</span><span class=sat-info-value></span></div><div class=sat-info-row><span class=sat-info-label>ALT</span><span class=sat-info-value></span></div><div class=sat-info-row><span class=sat-info-label>POS</span><span class=sat-info-value></span></div><div class=sat-info-row><span class=sat-info-label>CAT</span><span class=sat-info-value></span></div></div><div class=sat-info-footer><button class=sat-info-follow-btn>`),
  _tmpl$3 = /*#__PURE__*/_$template(`<span class=sat-info-value>—`);
/**
 * WorldView - Satellite Info Panel (SolidJS)
 * Displays satellite metadata when a satellite is selected.
 * Port from src/ui/sat-info-panel.ts
 */

import { Show, createMemo } from "solid-js";
import { selection } from "../../stores/selection";
import { formatCoordinates } from "../formatters";
import { useEntityPanel } from "./useEntityPanel";

/** Format velocity magnitude for display (km/s) */
function formatVelocity(velocity) {
  if (!velocity) return "—";
  const speed = Math.sqrt(velocity.x ** 2 + velocity.y ** 2 + velocity.z ** 2);
  return `${speed.toFixed(3)} KM/S`;
}

/** Format orbital altitude (always km-scale) */
function formatOrbitalAltitude(alt) {
  return alt >= 1000 ? `${(alt / 1000).toFixed(0)} km` : `${alt.toFixed(0)} m`;
}

/**
 * SatelliteInfo component
 * Displays satellite metadata when a satellite is selected
 */
export function SatelliteInfo() {
  const {
    isFollowing,
    handleFollow,
    handleClose
  } = useEntityPanel("satellite");
  const data = createMemo(() => {
    if (selection.type !== "satellite") return null;
    return selection.data;
  });
  return _$createComponent(Show, {
    get when() {
      return data();
    },
    children: satData => (() => {
      var _el$ = _tmpl$2(),
        _el$2 = _el$.firstChild,
        _el$3 = _el$2.firstChild,
        _el$4 = _el$3.nextSibling,
        _el$5 = _el$2.nextSibling,
        _el$6 = _el$5.firstChild,
        _el$7 = _el$6.firstChild,
        _el$8 = _el$7.nextSibling,
        _el$9 = _el$6.nextSibling,
        _el$0 = _el$9.firstChild,
        _el$10 = _el$9.nextSibling,
        _el$11 = _el$10.firstChild,
        _el$12 = _el$11.nextSibling,
        _el$13 = _el$10.nextSibling,
        _el$14 = _el$13.firstChild,
        _el$15 = _el$14.nextSibling,
        _el$16 = _el$13.nextSibling,
        _el$17 = _el$16.firstChild,
        _el$18 = _el$17.nextSibling,
        _el$19 = _el$16.nextSibling,
        _el$20 = _el$19.firstChild,
        _el$21 = _el$20.nextSibling,
        _el$22 = _el$5.nextSibling,
        _el$23 = _el$22.firstChild;
      _$addEventListener(_el$4, "click", handleClose, true);
      _$insert(_el$8, () => satData().name || "—");
      _$insert(_el$9, _$createComponent(Show, {
        get when() {
          return satData().noradId;
        },
        get fallback() {
          return _tmpl$3();
        },
        get children() {
          var _el$1 = _tmpl$();
          _$insert(_el$1, () => satData().noradId);
          _$effect(() => _$setAttribute(_el$1, "href", `https://www.satcat.com/sats/${satData().noradId}`));
          return _el$1;
        }
      }), null);
      _$insert(_el$12, () => formatVelocity(satData().velocity));
      _$insert(_el$15, (() => {
        var _c$ = _$memo(() => !!satData().position);
        return () => _c$() ? formatOrbitalAltitude(satData().position.alt) : "—";
      })());
      _$insert(_el$18, (() => {
        var _c$2 = _$memo(() => !!satData().position);
        return () => _c$2() ? formatCoordinates(satData().position.lat, satData().position.lng) : "—";
      })());
      _$insert(_el$21, () => satData().category?.toUpperCase() || "—");
      _$addEventListener(_el$23, "click", handleFollow, true);
      _$insert(_el$23, () => isFollowing() ? "UNFOLLOW" : "FOLLOW");
      return _el$;
    })()
  });
}
export default SatelliteInfo;
_$delegateEvents(["click"]);